/********************
 ACTION TYPES
 ********************/

 export const REGISTER = "REGISTER";
 export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
 export const REGISTER_ERROR = "REGISTER_ERROR";
 export const RESET_REGISTER = "RESET_REGISTER";